(function (angular, app) {
   "use strict";

   // Alert
   angular.module(app.modules.ui.name)
      .controller(app.modules.ui.controllers.alert, AlertController);

   // Injector  
   AlertController.$inject = ["$scope"
   , app.modules.ui.services.ui
   , app.modules.common.services.functions
   ];

   function AlertController($scope
      , ggUISvc
      , ggFunctions
      ){

       $scope.Temp = {
           window: ggFunctions.fetchWindowSize()
       }

      var ctrl = this;
      ctrl.isLoaded = false;
      ctrl.title = "Alert";
      ctrl.description = "";
      ctrl.classname = "success"; // success, warning, error;
      ctrl.buttons = [];
      ctrl.branding = app.Branding;


      if ($scope.$parent && $scope.$parent.ngDialogData) {
         var data = $scope.$parent.ngDialogData;
         
         ctrl.title = data.title ? data.title : null;
         ctrl.description = data.description ? data.description : null;
         ctrl.classname = data.classname ? data.classname : null;

         if (data.buttons) {
            ctrl.buttons = data.buttons; 
         }
      }

      ctrl.clickNext = function (buttonIndex) {
         ggUISvc.modal.close();

         var path = ctrl.buttons[buttonIndex].path;
         if (path && path != "") {
            ggFunctions.goToPage(ctrl.buttons[buttonIndex].path);
         }

         var cb = ctrl.buttons[buttonIndex].callback;
         if (cb) {
            cb();
         }

      }

      // Cancel Button, Close Modal
      ctrl.cancel = function () {
         ggUISvc.modal.close();
      }
   }
}(angular, app));
